export class SowRetainedHoursStats {
  sowId!: number
  totalHours!: number
  usedHours!: number
  remainingHours!: number
}
